import React, { createContext, useState, useEffect } from 'react';
import { IContent } from '../../interfaces/Content';
import { IListInformationPopup } from '../../interfaces/ListInformationPopup';


export interface IListInformationModalContext {
    showListInformationModal: boolean,
    setShowListInformationModal: (show: boolean) => void,
    setContent: (content: IContent | null) => void,
    listId: number | null,
    checkIfHasListInformationModal: () => boolean,
    listInformationPopupContent: IListInformationPopup | null
}

export const ListInformationModalDefaultValues = {
    showListInformationModal: false,
    setShowListInformationModal: ()=>{},
    setContent: () => {},
    checkIfHasListInformationModal: ()=>false,
    listId: null,
    listInformationPopupContent: null
}

export const ListInformationModalContext = createContext<IListInformationModalContext>(ListInformationModalDefaultValues);

const ListInformationModalProvider = ({children}:{children: React.ReactNode | React.ReactNode[]}) => {
    const [showListInformationModal, setShowListInformationModal] = useState<boolean>(false);
    const [listInformationPopupContent, setListInformationPopupContent] = useState<IListInformationPopup | null>(null)
    const [content, setContent] = useState<IContent | null>();

    useEffect(() => {
        if (content?.infoModal) {
            setListInformationPopupContent(content.infoModal)
        } else {
            setShowListInformationModal(false);
        }
    }, [content?.id])

    function checkIfHasListInformationModal() {
        return !!content?.infoModal
    }
    
    const listInformationModalValues = {
        showListInformationModal,
        setShowListInformationModal,
        setContent,
        checkIfHasListInformationModal,
        listId: content?.id ?? null,
        listInformationPopupContent
    };
    
    return (
        <ListInformationModalContext.Provider value={listInformationModalValues}>
            {children}
        </ListInformationModalContext.Provider>
    )
};

export default ListInformationModalProvider;